import { UtilService } from './../../../../shared/services/util/util.service';
import { Component, Input, OnChanges, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { StorageService, VariablesService } from '../../../../shared/services';
import { MatFormFieldAppearance } from '@angular/material/form-field';

interface IErrors {
  required?: string;
  minlength?: string;
  maxlength?: string;
  min?: string;
  max?: string;
  email?: string;
  password?: string;
  pattern?: string;
  custom?: string;
}
@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss']
})
export class InputComponent implements OnChanges {

  @Input() public inputType; /**Type of the input like text, email etc */
  @Input() public placeHolder; /**Place holder of that input */
  @Input() public label; /**Label of the input */
  @Input() public control: FormControl|any; /**Form control of the input */
  @Input() public group: FormGroup; /**Form group of the input */
  @Input() public icon; /**Icon of the input */
  @Input() public preIcon; /**Icon of the input */
  @Input() public hint; /**Hint text of the input */
  @Input() public hintDirection?; /**Align hint to left or right. Default: right */
  @Input() public hintLength; /**Material hint placeholder length */
  @Input() public info; /**Info texts like title, label, placeholders etc */
  @Input() public currency;
  @Input() public readonly;
  @Input() public id;
  @Input() public appearance: MatFormFieldAppearance = 'legacy';
  @Input() public errorMessage: IErrors; /**Error Messages of perticular input */
  @Input() public disableWheel = true;
  @Input() fieldRequired = 'Field Required';
  @Input() isAnonymous;
  @Output() OnChange = new EventEmitter();
  @Output() onFocusOut = new EventEmitter();
  @Output() enter = new EventEmitter();

  public error;
  inputFocused = false;
  showPopover = false;
  @ViewChild('inputRef', { static: true }) inputRef: ElementRef<HTMLInputElement>;

  constructor(
    public utilService: UtilService,
    public storageService: StorageService,
    public vars: VariablesService,
    public router: Router
  ) { }

  ngOnChanges() {
    if (this.control && this.control.invalid && this.control.touched) {
      this.error = this.control.invalid;
    }
  }

  onInputChange() {
    this.OnChange.emit(this.control.value);
  }

  onKeyDown(event) {
    // enter pressed
    if (event.keyCode === 13) {
      this.enter.emit(event);
    } else {
      event.stopPropagation();
    }
  }

  checkError() {
    if (this.control && this.control.invalid && this.control.touched) {
      this.error = this.control.invalid;
    } else {
      this.onInputChange();
    }
  }
  /**Open popover login */
  checkLength(data) {
    if (data) {
      return false;
    } else {
      return true;
    }
  }

  focusFunction() {
    this.inputFocused = true;
  }

  focusOutFunction() {
    if (this.control && this.control.value === '') {
      this.inputFocused = false;
    }
    this.onFocusOut.emit();
  }

  // fieldRequired() {
  //   return this.storageService.get('language') === 'English' ? 'Field Required' : 'जवाब आवश्यक है';
  // }
}


